import { render, staticRenderFns } from "./ContactRelation.vue?vue&type=template&id=a94d75f6&scoped=true&"
import script from "./ContactRelation.vue?vue&type=script&lang=js&"
export * from "./ContactRelation.vue?vue&type=script&lang=js&"
import style0 from "./ContactRelation.vue?vue&type=style&index=0&id=a94d75f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94d75f6",
  null
  
)

export default component.exports